import { dcaBaseUrl } from './dca'

export const segmentsUrl = `${dcaBaseUrl}/segments`
export const segmentQueryBuilderUrl = `${dcaBaseUrl}/segment`
